import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreOfferDetails as orgModuleConfig } from 'org/configs/modules.config';
import orgConfig from 'org/configs/org.config';

const { instoreLabel } = orgConfig;

const defaultConfig = {
  defaults: {
    instoreOnlyPillText: 'In-store offer only',
    getEasyLinkTitleLinkedBefore: (displayRate, currency, rclonMerchantName) => (
      <>
        Good news!<br />
        You're ready to earn {displayRate} {currency}<span className="mn_noWrap">{instoreLabel}</span>{' '}
        at {rclonMerchantName} <span className="mn_dot">.</span>
      </>
    ),
    getEasyLinkTitleLinkedNow: (formattedMerchantName) => (
      <>
        Good news!<br />
        We've linked your participating card(s)
        to {formattedMerchantName} <span className="mn_noWrap">in-store</span> offers{' '}
        <span className="mn_dot">.</span>
      </>
    ),
    getEasyLinkMottoLinkedBefore: () => '',
    getEasylinkMottoLinkedNow: () => '',
  },
};

export default mergeModuleConfigs(defaultConfig, orgModuleConfig);
